import React from 'react'
import { Layer } from 'react-mapbox-gl'

const Default = () => <Layer id='default' />

export default Default



// WEBPACK FOOTER //
// ./src/layers/Default.js